import React, { useEffect, useState } from "react";
import { baseUrl } from "../../config/baseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import { format, isValid, parseISO } from "date-fns";
import EduPagination from "../edu-pagination/edu-pagination";
import UnarchiveModal from "../edu-helper/unarchive-modal";

// Helper function to safely format dates
const safeFormatDate = (dateString, formatString) => {
  if (!dateString) return "N/A";

  try {
    // Try to parse the date string
    const date = parseISO(dateString);
    if (isValid(date)) {
      return format(date, formatString);
    }
    return "Invalid Date";
  } catch (error) {
    return "Invalid Date";
  }
};

export const EduCompanyArchiveList = ({
  userType,
  forceUpdate,
  setForceUpdate,
  pageNumberArchive,
  setPageNumberArchive,
  pageLimitArchive,
  setPageLimitArchive,
  setArchiveCount,
}) => {
  const [archiveCompanyList, setArchiveCompanyList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [unarchiveId, setUnarchiveId] = useState();

  const getArchiveCompanyList = async () => {
    try {
      const url = `${baseUrl}/archived_company_api/?per_page=${pageLimitArchive}&page=${pageNumberArchive}`;

      let response = await axios(url, {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });

      if (response?.status === 200) {
        const responseData = response.data;
        setTotalCount(responseData.count || 0);
        setArchiveCompanyList(responseData.data || []);
        // Update the archive count in parent component
        if (setArchiveCount) {
          setArchiveCount(responseData.count || 0);
        }
      } else {
        setArchiveCompanyList([]);
        setTotalCount(0);
        if (setArchiveCount) {
          setArchiveCount(0);
        }
      }
    } catch (error) {
      console.error("Error fetching archive company list:", error);
      setArchiveCompanyList([]);
      setTotalCount(0);
      if (setArchiveCount) {
        setArchiveCount(0);
      }
    }
  };

  const unarchiveCompany = async (companyId) => {
    try {
      // Find the company to get its current archived status
      const company = archiveCompanyList.find((comp) => comp.id === companyId);
      const currentArchivedStatus = company?.archived || true;

      const response = await axios(
        `${baseUrl}/archive_restore_api/${companyId}/?is_archived=False`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        }
      );

      if (response?.status === 200) {
        setForceUpdate(!forceUpdate);
        getArchiveCompanyList(); // Refresh the list
      }
    } catch (error) {
      console.error("Error unarchiving company:", error);
    }
  };

  useEffect(() => {
    getArchiveCompanyList();
  }, [forceUpdate, pageNumberArchive, pageLimitArchive]);

  return (
    <div className="cards user-list">
      <div className="row">
        <div className="col-lg-12">
          <div className="table table-responsive custom-table management-table company-archive-table">
            <table className="table table-borderless">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Company Name</th>
                  <th>Description</th>
                  <th>Archived At</th>
                  {userType === "SUPER_ADMIN" && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {archiveCompanyList.length > 0 ? (
                  archiveCompanyList.map((ul, idx) => (
                    <tr key={ul?.id}>
                      <td>
                        {idx + 1 + pageLimitArchive * (pageNumberArchive - 1)}
                      </td>
                      <td style={{ textTransform: "capitalize" }}>
                        {ul?.name}
                      </td>
                      <td>{ul?.description}</td>
                      <td>
                        {safeFormatDate(
                          ul?.archived_at || ul?.updated_at,
                          "MMM dd, yyyy"
                        )}
                      </td>
                      {userType === "SUPER_ADMIN" && (
                        <td>
                          <div className="d-flex flex-row">
                            <Link
                              role="button"
                              className="btn btn-outline-success ms-2 btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#unarchivemodal"
                              onClick={() => setUnarchiveId(ul?.id)}
                            >
                              <i className="fa fa-cloud-download" />
                            </Link>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <span>No archived companies available</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <EduPagination
              pageNumber={pageNumberArchive}
              setPageNumber={setPageNumberArchive}
              pageLimit={pageLimitArchive}
              setPageLimit={setPageLimitArchive}
              totalCount={totalCount}
            />
          </div>
        </div>
      </div>

      <UnarchiveModal unarchiveHandle={unarchiveCompany} id={unarchiveId} />
    </div>
  );
};
